import { render, staticRenderFns } from "./veStuIdxScoreConfigEdit.vue?vue&type=template&id=2025a688&scoped=true"
import script from "./veStuIdxScoreConfigEdit.vue?vue&type=script&lang=js"
export * from "./veStuIdxScoreConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025a688",
  null
  
)

export default component.exports